import React from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import coursesData from "../../data/coursesData";
// import "./RecordedCourse.css";
import "../../pages/VaidikVidhya/CourseDetail.css";

const RecordedCourse = () => {
  const { slug } = useParams();

  const course = coursesData.find((item) => item.slug === slug);

  if (!course) {
    return (
      <>
        <Header />
        <div className="record-not-found">
          <h2>Course Not Found</h2>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />

      {/* Hero */}

      <section className="record-hero">

        <div className="record-container">

          <div className="record-left">

            <span className="record-tag">
              RECORDED COURSE
            </span>

            <h1>{course.title}</h1>

            <p>
              Learn anytime, anywhere with lifetime access.
              Watch HD recorded classes at your own pace and
              master the complete course from beginner to
              advanced level.
            </p>

            <div className="record-price">

              <h2>{course.recorded.price}</h2>

              <span>Lifetime Access</span>

            </div>

            <Link
              to="/checkout"
              className="record-btn"
            >
              Enroll Now
            </Link>

          </div>

          <div className="record-right">

            <img
              src={course.image}
              alt={course.title}
            />

          </div>

        </div>

      </section>

      {/* Features */}

      <section className="record-features">

        <div className="record-container">

          <div className="section-title">

            <span>Why Choose Recorded Course</span>

            <h2>Course Features</h2>

          </div>

          <div className="record-grid">

            <div className="record-card">
              <h3>Lifetime Access</h3>
              <p>
                Watch unlimited times without expiry.
              </p>
            </div>

            <div className="record-card">
              <h3>HD Video Lessons</h3>
              <p>
                High quality videos with practical examples.
              </p>
            </div>

            <div className="record-card">
              <h3>Certificate</h3>
              <p>
                Get completion certificate after course.
              </p>
            </div>

            <div className="record-card">
              <h3>WhatsApp Support</h3>
              <p>
                Direct support from our expert team.
              </p>
            </div>

            <div className="record-card">
              <h3>Download Notes</h3>
              <p>
                PDF Notes included with every module.
              </p>
            </div>

            <div className="record-card">
              <h3>Practical Assignments</h3>
              <p>
                Practice exercises after each lesson.
              </p>
            </div>

          </div>

        </div>

      </section>

      {/* What's Included */}

      <section className="record-includes">

        <div className="record-container">

          <div className="section-title">

            <span>Included</span>

            <h2>What You'll Get</h2>

          </div>

          <ul className="include-list">

            <li>✔ Complete Video Course</li>

            <li>✔ Lifetime Access</li>

            <li>✔ Downloadable PDF Notes</li>

            <li>✔ Practice Assignments</li>

            <li>✔ WhatsApp Support</li>

            <li>✔ Completion Certificate</li>

            <li>✔ Future Course Updates</li>

          </ul>

        </div>

      </section>

      {/* Pricing */}

      <section className="record-pricing">

        <div className="record-container">

          <div className="price-box">

            <h2>{course.recorded.price}</h2>

            <h4>{course.title}</h4>

            <p>
              One-time payment with lifetime access.
            </p>

            <Link
              to="/checkout"
              className="buy-btn"
            >
              Buy Recorded Course
            </Link>

          </div>

        </div>

      </section>

      {/* CTA */}

      <section className="record-cta">

        <div className="record-container">

          <h2>
            Ready to Start Learning?
          </h2>

          <p>
            Enroll today and begin your journey with
            Vaidik Vidhya™.
          </p>

          <Link
            to="/checkout"
            className="record-btn"
          >
            Enroll Now
          </Link>

        </div>

      </section>

      <Footer />

    </>
  );
};

export default RecordedCourse;